export default "__VITE_ASSET__WnQqniEE__"